export const DEFAULT_UPLOAD_ERRORS_ITEMS_PAGE_NUMBER = 20;
